import * as auth from '@/utils/auth.js';
import AccountInformation from './../components/AccountInformation.vue';
import cloneDeep from 'clone';
import Vue from 'vue';

export default {
  components: {
    AccountInformation
  },

  data() {
    return {
      selectedRoles: [],
      accountInfo: null,
      errors: {}
    };
  },

  computed: {
    isAdmin() {
      return auth.readActiveRole() === 'admin';
    },
    profile() {
      return this.$store.state.app.user;
    },
    roles() {
      let roles = [];
      const exclude = cloneDeep(this.$config.excludedRoles);
      if (auth.readActiveRole() === 'bounty-admin') {
        exclude.splice(exclude.indexOf(8), 1);
      }
      if (auth.readActiveRole() === 'advert-admin') {
        exclude.splice(exclude.indexOf(9), 1);
      }
      this.$config.roles.forEach((val, key) => {
        roles.push({ id: key, name: this.getRoleName(key) });
      });
      if (!this.isAdmin) {
        roles = roles.filter(({ id }) => !exclude.includes(id));
      }
      return roles;
    }
  },

  methods: {
    logoutFromAllDevices() {
      this.$api.auth.put(`/logout-all-devices`).then(() => {
        Vue.api.logout();
      });
    },
    getRoleName(id) {
      return this.prettify(this.$config.roles.get(id));
    },
    prettify(input) {
      if (!input) {
        return '';
      }
      let result = '';
      const words = input.split('-');
      words.forEach(word => {
        result += word.charAt(0).toUpperCase() + word.slice(1) + ' ';
      });

      return result;
    },
    updateProfile() {
      const form = cloneDeep(this.accountInfo);
      form.phone = form.wallets.phone;
      delete form.password;
      delete form.wallets.phone;

      this.$api.auth.put(`/profile`, form).then(
        () => {
          this.$api.auth
            .put(`/auth/refresh-token`, {
              refreshToken: auth.readRefreshToken()
            })
            .then(
              data => {
                if (data) {
                  Vue.api.updateCredentials({
                    token: data.accessToken,
                    refreshToken: data.refreshToken,
                    email: auth.readUser()
                  });
                  this.$store.dispatch('fetchUser');
                  this.errors = {};
                  this.$notify('alert', {
                    text: this.$t('profileUpdated'),
                    variant: 'success',
                    time: 5000
                  });
                }
              },
              e => {
                e.response.data.detail &&
                  this.$notify('alert', {
                    text: e.response.data.detail,
                    variant: 'danger',
                    time: 5000
                  });
              }
            );
        },
        e => {
          this.errors = {};

          if (e.response.status === 400) {
            this.errors = e.response.data.error
              ? this.$parseAuthErrors(e.response.data.error.errors)
              : {};
          } else {
            const text = e.response.data.error
              ? e.response.data.error.message
              : this.$t('somethingWentWrong');
            this.$notify('alert', {
              text,
              variant: 'danger',
              time: 5000
            });
          }
        }
      );
    }
  },

  created() {
    this.accountInfo = cloneDeep(this.profile);
    this.accountInfo.wallets.phone = cloneDeep(this.profile.phone);
    this.selectedRoles = this.accountInfo.roles.map(role => ({
      id: role,
      name: this.getRoleName(role)
    }));
  }
};
